var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-select',{model:{value:(_vm.templateId),callback:function ($$v) {_vm.templateId=$$v},expression:"templateId"}},_vm._l((_vm.emailTemplates),function(item,index){return _c('vs-select-item',{key:index,attrs:{"value":item.id,"text":item.name}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }